
import utils from './utils.js'; //console.log('utils:', utils)
import http from './http';
import settings from './settings';
import labels from './labels';
import featureFlags from './featureFlags'
import tenant from './tenant'
import reactiveWebStorage from './reactiveWebStorage.js';

export default new class user {
  constructor() {
    this.baseUrl = `${settings.nodeRoot}/users`;
    this.currentUserPromise;

    reactiveWebStorage.registerKey({
      key: 'isGuest',
      storageType: 'sessionStorage',
      valueType: 'boolean',
      defaultValue: false,
    });

    let me = this;
    this.beforeRouteEnter = (to, from, next) => {
      try {

        if (!to.meta.permissions) {
          next()
          return
        }

        if (to.meta.permissions.admin && me.currentUser.isSysAdmin){
          next()
        } else {
          next(false)
          window.portalEventBus.$emit('integrify-portal:route', settings.frontEndRoot.angular.full)
          setTimeout(() => { alert(labels.getLocalLabel('Permission Denied')) }, 250); // needs delay to prevent next route from briefly being shown
        }
      }
      catch(e) {
        console.log(e)
        next(false)
        window.portalEventBus.$emit('integrify-portal:route', settings.frontEndRoot.angular.full)
      }
    }
  }

  get(token, { signal } = {}) {
    // when token is provided, it waits for current query to finish so that they do not conflict,
    // and then starts a new query ignoring cache for current user.
    if (!this.currentUserPromise || token) {
      const prevPromise = this.currentUserPromise;
      this.currentUserPromise = (async () => {
        await prevPromise;

        // if token explicitly was provided, skip cache
        if (!token && sessionStorage.getItem('currentUser')) {
          this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'))
          return this.currentUser;
        } 

        let options = { signal };
        if (token) {
          // OP 9/8/2021: added this section to pass guest token in auth header
          // for urls that end with guest=true to prevent errors that occur
          // due to integrifyToken cookie not being set when this function gets called
          options.headers = {
            Authorization: token
          }
        }

        const url = `/api/user/current?includePermissions=true`;

        const response = await http.get(url, options).catch((e) => {
          console.log('failed to get current user');
          throw e;
        });
        
        let currentUser = this.currentUser = response.data;

        if (Array.isArray(currentUser.Properties)) {
            currentUser.Properties = utils.getLegitJsonFromArrays(currentUser.Properties);
        }
        const sysAdmin = currentUser.permissions.find((p) => {
          return p.objectType == 'system'
        })

        currentUser.isSysAdmin = sysAdmin ? true : false;
        delete currentUser.Properties.LogoURL; //we dont use this anymore in the ui. 'Large dataURL will put this over this limit for session storage;
        sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
        if (currentUser.SID.toLowerCase() == '64ec8fc9-b426-4376-a1a4-3ad16f0f9906') {
          this.setIsGuest(true);
        }
        return currentUser;
      })();
    }

    return this.currentUserPromise;
  }

 
  async isSysAdmin() {
    try {
      //let response = await http.get(`${settings.microServiceRoot}/permissions/sys-admin`)
      //return response.data.isSysAdmin
      const currentUser = await this.get();
      return currentUser.isSysAdmin
    }
    catch {
      return false
    }
  }

  isGuest() {
    return reactiveWebStorage.get('isGuest');
  }

  setIsGuest(isGuest) {
    reactiveWebStorage.set('isGuest', isGuest);
  }

  onIsGuestUpdate(handler) {
    return reactiveWebStorage.onUpdate('isGuest', handler);
  }

  navGuard(to, from, next, objectType, permissionType) {
    this.get().then((currentUser) => {
      const hasPermissions = this.hasPermission(objectType, permissionType);
      if (!hasPermissions) {
        alert(labels.getLocalLabel('Permission denied'));
        if (from.path !== '/') next(false) // next({path: from.path});
        else this.redirectFromRestrictedPage();
        return;
      }

      if (objectType.toLowerCase() === 'aiconnection'){
        tenant.hasIntelligentDocumentModule().then((enabled) => {
          if (!enabled){
            alert(labels.getLocalLabel('Feature disabled'));
            if (from.path !== '/') {
              next(false);
            } else {
              this.redirectFromRestrictedPage();
            }
            return;
          }
        });
      }

      next();
    })
  }

  navGuardAdmin(to, from, next, objectType = '') {
    this.isSysAdmin().then((isSysAdmin) => {
      if (!isSysAdmin) {
        alert(labels.getLocalLabel('Permission denied'));
        if (from.path !== '/') next(false) // next({path: from.path});
        else this.redirectFromRestrictedPage();
        return;
      }

      if (objectType === 'aiconnection'){
        tenant.hasIntelligentDocumentModule().then((enabled) => {
          if (!enabled){
            alert(labels.getLocalLabel('Feature disabled'));
            if (from.path !== '/') {
              next(false);
            } else {
              this.redirectFromRestrictedPage();
            }
            return;
          }
        });
      }

      next();
    });
  }

  redirectFromRestrictedPage() {
    const previousUrl = utils.getPrevUrl();
    window.location.href = previousUrl;
  }

  hasPermission(objectType, permissionType, objectSid, categorySid, publishStatus) {
    try {
      let permissions = this.currentUser.permissions;
      objectType = objectType.toLowerCase();

      // first check to see if they have sysadmin permissions
      let sysadminPerm = permissions.find((p) => {
        return ( p.objectType === "system" ) && this.permissionBitMaskCheck(p.permissions, permissionType);
      })
      if (sysadminPerm) return true;

      // next check based on object type and permissions
      let basicPerms = permissions.filter((p) => {
        return p.objectType === objectType && this.permissionBitMaskCheck(p.permissions, permissionType);
      })
      //if they don't have permissions based on the permissionType and objectType then no need to check further
      if (basicPerms.length === 0) return false;

      // assuming they have basic permission (which may be all that is needed to test for top-level navigation)
      // check for scoped perms if passed in
      if (objectSid) objectSid = objectSid.toLowerCase();
      if (categorySid) categorySid = categorySid.toLowerCase();
      if (publishStatus) publishStatus = publishStatus.toLowerCase();

      if (objectSid || categorySid) {
        let scopedPerms = basicPerms.find((p) => {
          let match = (
            p.ownerType === 'system' ||
              p.ownerSid === objectSid ||
              p.ownerSid === categorySid
          );
          if (match && publishStatus) {
            match = (p.mode === publishStatus || p.mode === 'any')
          }
          return match;
        });

        return scopedPerms ? true : false;
      }
      else { // no object or category scopes passed in so this is a basic permission check used for nav menus etc.
        return true;
      }
    }
    catch(e) {
      return false
    }
  }


  permissionBitMaskCheck(allowedPermissionBitmask, requestedPermission){
    const permission = {
      none: 0,
      viewconfig: 1,
      edit: 2,
      create: 4,
      delete: 8,
      run: 16,
      participate: 32,
      grant: 64,
      manage: 128,
      monitor: 256,
      publish: 512 };

    return permission[requestedPermission.toLowerCase()] & allowedPermissionBitmask;

  }

}
